module.exports = __webpack_public_path__ + "static/img/other_FAQ_pic01.77e8fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other_FAQ/other_FAQ_pic01.png
// module id = 553
// module chunks = 1